module.exports = __webpack_public_path__ + "static/media/tum-urunler.3dd202ad.svg";